//
// pastDateDisplay
//
// Displays a past date in user friendly format: hh:mm, yesterday, mm/dd hh:mm, etc.
//
// Accepts:
// - ISO 8601: "2020-04-01T12:16:54.000Z" or "2020-04-01T12:16:54Z"
// - MySQL format: "2020-04-01 12:16:54" or "2020-04-01 12:16:54.5"
//
import utcDateTimeToJsDate from './utcDateTimeToJsDate';

export default (pastDateTime, numericOnly, short) => {
  const past = utcDateTimeToJsDate(pastDateTime);

  // testDate is going to take multiple values,
  // and be compared to the display date, to see how old that one is
  const testDate = new Date();

  // const locale = navigator.language;
  const locale = 'fr-FR';

  // check the date is not in the future
  if (past > testDate) {
    // Same day
    return (`${past.toLocaleString(
      locale,
      {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
      },
    )} (!)`);
  }

  // set testDate to today, midnight
  testDate.setHours(0, 0, 0, 0);
  if (past >= testDate) {
    // Same day
    return (past.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' }));
  }

  if (!numericOnly) {
  // set testDate to yesterday, midnight
    testDate.setDate(testDate.getDate() - 1);
    if (past >= testDate) {
    // Yesterday
      return (`Hier, ${past.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })}`);
    }

    // set testDate to 6 days ago, midnight
    testDate.setDate(testDate.getDate() - 5);
    if (past >= testDate) {
    // last 6 days
      return (past.toLocaleTimeString(locale, { weekday: 'long', hour: '2-digit', minute: '2-digit' }));
    }
  }

  // set testDate to 6 months ago, midnight
  testDate.setMonth(testDate.getMonth() - 6);
  if (past >= testDate) {
    // Last x months
    return (past.toLocaleString(
      locale,
      {
        day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
      },
    ));
  }

  if (short) {
    return (past.toLocaleString(
      locale,
      {
        day: '2-digit', month: '2-digit', year: 'numeric',
      },
    ));
  }

  return (past.toLocaleString(
    locale,
    {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    },
  ));
};
